// @ts-strict-ignore
import React, { useContext } from 'react';
import { TextField, TextArea } from '@usealloy/component-library';
import { StyledAggregationNameDescriptionContainer } from './styles';
import { AggregationEditorContext } from './context';
import type { AggregationSourceData } from './types';

type NameDescriptionKey = keyof Pick<AggregationSourceData, 'name' | 'description'>;

const AggregationNameAndDescription = () => {
  const {
    sourceData, setSourceData, validationErrors,
  } = useContext(AggregationEditorContext);
  const handleChange = (field: NameDescriptionKey) => (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setSourceData(prev => ({ ...prev, [field]: e.target.value }));
  };
  return (
    <StyledAggregationNameDescriptionContainer>
      <TextField
        label="Aggregation Name"
        value={sourceData.name}
        onChange={handleChange('name')}
        type="text"
        required
        error={validationErrors.name}
      />
      <TextArea
        label="Description"
        value={sourceData.description}
        onChange={handleChange('description')}
        rows={3}
        required
        placeholder="Enter a description for your aggregation."
        error={validationErrors.description}
      />
    </StyledAggregationNameDescriptionContainer>
  );
};

export default AggregationNameAndDescription;
